import crypto from 'crypto';

export const getBrazeExternalId = (email: string): string | false => {
  if (!email) return false;

  const normalizedEmail = email.toLowerCase().trim();

  return crypto
    .createHash('md5')
    .update(normalizedEmail)
    .digest('hex')
    .toUpperCase();
};
